export default "__VITE_ASSET__b72185fa__"